import useFormPlayground from './useFormPlayground'
import Button from '../../../../control/button/button'
import { Form } from 'react-final-form'
import TextField from '../../../../control/textfield/textfield'
import Autocomplete from '../../../../control/autocomplete/autocomplete'
import DatePicker from '../../../../control/datepicker/datepicker'
import MultiSelect from '../../../../control/multiSelect/multiSelect'

import UploadFile from './uploadFile/uploadFileTest'
import { validateEmail } from '../../../../utilities/validate'
import arrayMutators from 'final-form-arrays'
import { FieldArray } from 'react-final-form-arrays'
import { Grid } from '@material-ui/core'
import DateRangePicker from '../../../../control/datepicker/DateRangePicker'
import moment from 'moment'
const data = [
    {
        id: 10,
        no: 1,
        value: 'บันทึกข้อความแจ้งความประสงค์ยื่นเสนอข้อเสนอโครงการวิจัย/โครงร่างวิทยานิพนธ์ เพื่อขอรับการพิจารณาด้านจริยธรรมการวิจัยในคน',
        name_en:
            'บันทึกข้อความแจ้งความประสงค์ยื่นเสนอข้อเสนอโครงการวิจัย/โครงร่างวิทยานิพนธ์ เพื่อขอรับการพิจารณาด้านจริยธรรมการวิจัยในคน',
        code: null,
        subtopic: [],
    },
    {
        id: 11,
        no: 2,
        name_th: 'แบบฟอร์มขอรับการพิจารณาจริยธรรมการวิจัยในคน',
        name_en: 'แบบฟอร์มขอรับการพิจารณาจริยธรรมการวิจัยในคน',
        code: 'AF 03-07',
        subtopic: [],
    },
    {
        id: 12,
        no: 3,
        name_th: 'เอกสารข้อมูลสำหรับกลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย',
        name_en: 'เอกสารข้อมูลสำหรับกลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย',
        code: 'AF 04-07',
        subtopic: [],
    },
    {
        id: 13,
        no: 4,
        name_th: 'หนังสือยินยอมของกลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย',
        name_en: 'หนังสือยินยอมของกลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย',
        code: 'AF 05-07',
        subtopic: [],
    },
    {
        id: 14,
        no: 5,
        name_th: 'บันทึกข้อความขอยกเว้นหนังสือยินยอม/การขอความยินยอม',
        name_en: 'บันทึกข้อความขอยกเว้นหนังสือยินยอม/การขอความยินยอม',
        code: 'AF 07-07',
        subtopic: [],
    },
    {
        id: 15,
        no: 6,
        name_th:
            'แผนการดำเนินงานตลอดโครงการ ได้แก่ ตารางกำหนดช่วงระยะเวลา กิจกรรมการวิจัยทุกขั้นตอน รวมทั้งประมาณการด้านเวลาในการขอรับการพิจารณาจริยธรรมการวิจัยในคน',
        name_en:
            'แผนการดำเนินงานตลอดโครงการ ได้แก่ ตารางกำหนดช่วงระยะเวลา กิจกรรมการวิจัยทุกขั้นตอน รวมทั้งประมาณการด้านเวลาในการขอรับการพิจารณาจริยธรรมการวิจัยในคน',
        code: null,
        subtopic: [],
    },
    {
        id: 16,
        no: 7,
        name_th: 'ประวัติและประสบการณ์ของผู้วิจัยซึ่งแสดงว่ามีความสามารถดำเนินโครงการวิจัยนี้ได้',
        name_en: 'ประวัติและประสบการณ์ของผู้วิจัยซึ่งแสดงว่ามีความสามารถดำเนินโครงการวิจัยนี้ได้',
        code: null,
        subtopic: [],
    },
    {
        id: 17,
        no: 8,
        name_th:
            'ข้อเสนอโครงการวิจัยฉบับสมบูรณ์/โครงร่างวิทยานิพนธ์ฉบับสมบูรณ์ พิมพ์สองหน้า ซึ่งครอบคลุมเนื้อหา ดังต่อไปนี้',
        name_en:
            'ข้อเสนอโครงการวิจัยฉบับสมบูรณ์/โครงร่างวิทยานิพนธ์ฉบับสมบูรณ์ พิมพ์สองหน้า ซึ่งครอบคลุมเนื้อหา ดังต่อไปนี้',
        code: null,
        subtopic: [
            {
                id: 1,
                no: 1,
                name_th: 'ชื่อโครงการวิจัยเป็นภาษาไทยและภาษาอังกฤษ',
                name_en: 'ชื่อโครงการวิจัยเป็นภาษาไทยและภาษาอังกฤษ',
                code: null,
            },
            {
                id: 2,
                no: 2,
                name_th: 'ความสำคัญและที่มาของปัญหาที่ทำวิจัย',
                name_en: 'ความสำคัญและที่มาของปัญหาที่ทำวิจัย',
                code: null,
            },
            {
                id: 3,
                no: 3,
                name_th: 'การทบทวนวรรณกรรม วัตถุประสงค์ และขอบเขตของโครงการวิจัย',
                name_en: 'การทบทวนวรรณกรรม วัตถุประสงค์ และขอบเขตของโครงการวิจัย',
                code: null,
            },
            {
                id: 4,
                no: 4,
                name_th: 'กระบวนการวิจัยและขั้นตอนการดำเนินงาน (โปรดเน้นวิธีสุ่ม/เลือกตัวอย่างและวิธีเก็บข้อมูล)',
                name_en: 'กระบวนการวิจัยและขั้นตอนการดำเนินงาน (โปรดเน้นวิธีสุ่ม/เลือกตัวอย่างและวิธีเก็บข้อมูล)',
                code: null,
            },
            {
                id: 5,
                no: 5,
                name_th:
                    'กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย เกณฑ์การคัดเลือกผู้มีส่วนร่วมในการวิจัยและเกณฑ์พิจารณาให้ผู้มีส่วนร่วมในการวิจัยออกจากโครงการ และอื่น ๆ (โปรดระบุเกณฑ์การคัดเลือกตัวอย่างเข้าและเกณฑ์การคัดเลือกตัวอย่างออกจากการวิจัยอย่างละเอียด)',
                name_en:
                    'กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย เกณฑ์การคัดเลือกผู้มีส่วนร่วมในการวิจัยและเกณฑ์พิจารณาให้ผู้มีส่วนร่วมในการวิจัยออกจากโครงการ และอื่น ๆ (โปรดระบุเกณฑ์การคัดเลือกตัวอย่างเข้าและเกณฑ์การคัดเลือกตัวอย่างออกจากการวิจัยอย่างละเอียด)',
                code: null,
            },
            {
                id: 6,
                no: 6,
                name_th: 'รายละเอียดเกี่ยวกับวิธีการติดต่อและวิธีการเข้าถึงผู้มีส่วนร่วมในการวิจัย',
                name_en: 'รายละเอียดเกี่ยวกับวิธีการติดต่อและวิธีการเข้าถึงผู้มีส่วนร่วมในการวิจัย',
                code: null,
            },
            {
                id: 7,
                no: 7,
                name_th:
                    'วิธีการพิทักษ์สิทธิ ป้องกันความเสี่ยง และรักษาความลับของกลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย',
                name_en:
                    'วิธีการพิทักษ์สิทธิ ป้องกันความเสี่ยง และรักษาความลับของกลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย',
                code: null,
            },
            { id: 8, no: 8, name_th: 'รายการเอกสารอ้างอิง', name_en: 'รายการเอกสารอ้างอิง', code: null },
            {
                id: 9,
                no: 9,
                name_th: 'ประมาณการด้านงบประมาณหมวดต่าง ๆ ที่ผู้วิจัยได้รับ/จะได้รับทุน หรือใช้ทุนส่วนตัว',
                name_en: 'ประมาณการด้านงบประมาณหมวดต่าง ๆ ที่ผู้วิจัยได้รับ/จะได้รับทุน หรือใช้ทุนส่วนตัว',
                code: null,
            },
            {
                id: 10,
                no: 10,
                name_th:
                    'เครื่องมือวิจัย เช่น แบบสอบถาม โปรแกรมดำเนินการทดลอง คู่มือ ฯลฯ ที่ผ่านการพิจารณาจากผู้ทรงคุณวุฒิแล้ว',
                name_en:
                    'เครื่องมือวิจัย เช่น แบบสอบถาม โปรแกรมดำเนินการทดลอง คู่มือ ฯลฯ ที่ผ่านการพิจารณาจากผู้ทรงคุณวุฒิแล้ว',
                code: null,
            },
            {
                id: 11,
                no: 11,
                name_th: 'เอกสารอื่นๆ เช่น เอกสารประชาสัมพันธ์ แผ่นพับโฆษณา แผ่นปลิวโฆษณา ฯลฯ',
                name_en: 'เอกสารอื่นๆ เช่น เอกสารประชาสัมพันธ์ แผ่นพับโฆษณา แผ่นปลิวโฆษณา ฯลฯ',
                code: null,
            },
        ],
    },
]

const response = [
    {
        documentTopicID: 10,
        filename: 'TestExportReport_2052564.pdf',
        subtopic: [],
    },
    {
        documentTopicID: 10,
        filename: 'TestExportReport_10452564.pdf',
        subtopic: [],
    },
    {
        documentTopicID: 17,
        filename: 'ExportReport_14052564.pdf',
        subtopic: [
            {
                subtopicID: 1,
                page: 1,
            },
            {
                subtopicID: 2,
                page: 2,
            },
            {
                subtopicID: 3,
                page: 33,
            },
            {
                subtopicID: 4,
                page: 4,
            },
            {
                subtopicID: 5,
                page: 5,
            },
            {
                subtopicID: 6,
                page: 6,
            },
            {
                subtopicID: 7,
                page: 7,
            },
            {
                subtopicID: 8,
                page: 88,
            },
            {
                subtopicID: 9,
                page: 99,
            },
            {
                subtopicID: 10,
                page: 11,
            },
            {
                subtopicID: 11,
                page: 12,
            },
        ],
    },
]

const getUploadInit = () => {
    const uploadFileinit = data.map((itm: any, idx: number) => {
        return {
            uploadFileObj: {
                fileList: [],
                subTopicPageList: [],
                documentTopicID: itm.id,
            },
        }
    })

    uploadFileinit.forEach((itm) => {
        // if(itm.uploadFileObj.documentTopicID == )
        response.forEach((resItm) => {
            if (resItm.documentTopicID === itm.uploadFileObj.documentTopicID) {
                let objUpload = {
                    documentTopicID: resItm.documentTopicID,
                    fileToken: `${resItm.filename}_${resItm.documentTopicID}`, //fileToken
                    filename: resItm.filename,
                    fileID: `${resItm.filename}__${resItm.documentTopicID}`, //fileToken
                }
                //@ts-ignore
                itm.uploadFileObj.fileList.push(objUpload)
                //@ts-ignore
                itm.uploadFileObj.subTopicPageList = resItm.subtopic
            }
        })
    })

    return uploadFileinit
}

const mockData = [
    {
        value: 1,
        label: 'ร่าง',
        name_en: 'Draft',
    },
    {
        value: 2,
        label: 'ส่งเรื่องแล้ว',
        name_en: 'ส่งเรื่องแล้ว',
    },
    {
        value: 3,
        label: 'รับเรื่องแล้ว',
        name_en: 'รับเรื่องแล้ว',
    },
    {
        value: 4,
        label: 'กำหนดกรรมการแล้ว',
        name_en: 'กำหนดกรรมการแล้ว',
    },
    {
        value: 5,
        label: 'รอสังเคราะห์ความเห็น',
        name_en: 'รอสังเคราะห์ความเห็น',
    },
    {
        value: 6,
        label: 'ดำเนินการทำใบรับรอง',
        name_en: 'ดำเนินการทำใบรับรอง',
    },
    {
        value: 11,
        label: 'ร่าง',
        name_en: 'Draft',
    },
    {
        value: 12,
        label: 'ส่งเรื่องแล้ว',
        name_en: 'ส่งเรื่องแล้ว',
    },
    {
        value: 13,
        label: 'รับเรื่องแล้ว',
        name_en: 'รับเรื่องแล้ว',
    },
    {
        value: 14,
        label: 'กำหนดกรรมการแล้ว',
        name_en: 'กำหนดกรรมการแล้ว',
    },
    {
        value: 15,
        label: 'รอสังเคราะห์ความเห็น',
        name_en: 'รอสังเคราะห์ความเห็น',
    },
    {
        value: 16,
        label: 'ดำเนินการทำใบรับรอง',
        name_en: 'ดำเนินการทำใบรับรอง',
    },
]
type DialogPlaygroundType = ReturnType<typeof useFormPlayground>
const FormPlaygroundView = (props: DialogPlaygroundType) => {
    const { onSubmit } = props
    return (
        <div>
            <h1> Use Form Example:</h1>
            <div>
                <Form
                    onSubmit={onSubmit}
                    mutators={{
                        ...arrayMutators,
                    }}
                    initialValues={{
                        uploadFile: getUploadInit(),
                        date1: moment().format('yyyy-MM-DD'),
                        date2: moment().format('yyyy-MM-DD'),
                    }}
                >
                    {({ handleSubmit, form }) => {
                        return (
                            <>
                                <TextField name="place" materialInputProps={{ label: 'My Label', disabled: false }} />
                                <TextField
                                    name="num"
                                    materialInputProps={{ label: 'Number Textfield', disabled: false }}
                                    type={'number'}
                                />
                                <MultiSelect name="multiselecte" option={mockData} />

                                <TextField
                                    name="email"
                                    materialInputProps={{ label: 'email validate', disabled: false }}
                                    validates={[validateEmail]}
                                />

                                <Autocomplete
                                    name="autocomplete"
                                    materialInputProps={{ label: 'autocomplete' }}
                                    options={[
                                        { label: 'list1', value: '1' },
                                        { label: 'list2', value: '2' },
                                        { label: 'disable list', value: '3', disabled: true },
                                    ]}
                                />

                                <DatePicker name="date" label="My Date Picker" />
                                <Grid container>
                                    <Grid item xs={12}>
                                        <DateRangePicker
                                            names={{ start: 'date1', end: 'date2' }}
                                            label={'Date Range Label'}
                                        />
                                    </Grid>
                                </Grid>

                                <FieldArray name="uploadFile">
                                    {({ fields }) =>
                                        fields.map((name, index) => (
                                            <Grid container item xs={12} key={name} spacing={5}>
                                                <Grid container item xs={12} justify={'flex-end'}>
                                                    <UploadFile
                                                        name={`${name}.uploadFileObj`}
                                                        dataSource={data[index]}
                                                        label="Upload File"
                                                        topicID={data[index].id}
                                                        onChangeUpload={() => {}}
                                                        subTitleList={data[index].subtopic}
                                                        initialData={getUploadInit()}
                                                        required
                                                    />
                                                </Grid>
                                            </Grid>
                                        ))
                                    }
                                </FieldArray>

                                <Button color="primary" onClick={handleSubmit}>
                                    submit form
                                </Button>
                            </>
                        )
                    }}
                </Form>
            </div>
        </div>
    )
}

const FormPlayground = () => {
    const formPlayground = useFormPlayground()
    return <FormPlaygroundView {...formPlayground} />
}

export default FormPlayground
